var exports = {
  "Qs": "x4ddf2309--0d3ee1--content",
  "Qq": "x4ddf2309--0d3ee1--text",
  "hJ": "x4ddf2309--0d3ee1--counter",
  "UE": "x4ddf2309--0d3ee1--arrow",
};

module.exports = exports;
